
function filtering (justef){
    let authorities = JSON.parse(localStorage.getItem('authorities'))
    return authorities.indexOf(justef) != -1 
}
export default { filtering }